export default "__VITE_ASSET__DL1wF3H9__"